import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import styled from 'styled-components';
import { bodyCopyMedium } from '..';

export const ConditionContainer = styled.div`
	padding: 1rem;
	background-color: ${globalVars.secondaryBlue};
	border-radius: 4px;
`;
ConditionContainer.displayName = 'ConditionContainer';

export const ConditionText = styled.div`
	${bodyCopyMedium};
	font-weight: 700 !important;
	margin-top: 10px;
`;
ConditionText.displayName = 'ConditionText';

export const SelectConditionContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	> div {
		min-width: 100%;
	}
`;
SelectConditionContainer.displayName = 'SelectConditionContainer';
